import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { NotFoundComponent } from './pages/miscellaneous/not-found/not-found.component';
import { SsoWebLoginComponent } from './sso-web-login/sso-web-login.component';

export const routes: Routes = [
  {
    path: 'landing',
    loadChildren: () =>
      import('./landing-page/landing-page.module').then(
        (m) => m.LandingPageModule,
      ),
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'panduan',
    loadChildren: () =>
      import('./panduan/panduan.module').then((m) => m.PanduanModule),
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'app',
    loadChildren: () =>
      import('./pages/pages.module').then((m) => m.PagesModule),
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'privacy-policies',
    loadChildren: () =>
      import('./privacy-policies/privacy-policies.module').then(
        (m) => m.PrivacyPoliciesModule,
      ),
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'no-network',
    loadChildren: () =>
      import('./no-network/no-network.module').then((m) => m.NoNetworkModule),
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'monitoring',
    loadChildren: () =>
      import('./monitoring/monitoring.module').then((m) => m.MonitoringModule),
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'mobile-landing',
    loadChildren: () =>
      import('./mobile-landing/mobile-landing.module').then(
        (m) => m.MobileLandingModule,
      ),
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'public-monitor',
    loadChildren: () =>
      import('./public-monitor/public-monitor.module').then(
        (m) => m.PublicMonitorModule,
      ),
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'location-checker',
    loadChildren: () =>
      import('./location-checker/location-checker.module').then(
        (m) => m.LocationCheckerModule,
      ),
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./authentication/authentication.module').then(
        (m) => m.AuthenticationModule,
      ),
  },
  {
    path: 'settings',
    loadChildren: () =>
      import('./settings/settings.module').then((m) => m.SettingsModule),
  },
  {
    path: 'phone-validation',
    loadChildren: () =>
      import('./otp-validation/otp-validation.module').then(
        (m) => m.OtpValidationModule,
      ),
  },
  {
    path: 'mobile-absensi',
    loadChildren: () =>
      import('./presensi/presensi.module').then((m) => m.PresensiModule),
    runGuardsAndResolvers: 'always',
  },
  { path: 'candi', component: SsoWebLoginComponent },
  {
    path: 'mobile-update',
    loadChildren: () =>
      import('./app-update/app-update.module').then((m) => m.AppUpdateModule),
  },

  { path: '', redirectTo: 'app', pathMatch: 'full' },

  { path: '**', component: NotFoundComponent },
];

const config: ExtraOptions = {
  // PERBAIKAN 2: Matikan useHash agar selaras dengan PathLocationStrategy
  useHash: false,
  onSameUrlNavigation: 'ignore',
  relativeLinkResolution: 'legacy',
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
